import { defineNuxtPlugin } from '#app/nuxt'
import { LazyMappedComponent, LazyMappedComponents, LazyContentfulAccordionSection, LazyContentfulAnimation, LazyContentfulBadge, LazyContentfulCardCarouselSection, LazyContentfulColumns, LazyContentfulContentPage, LazyContentfulContentSection, LazyContentfulContentTabs, LazyContentfulCtaSection, LazyContentfulCustomHTML, LazyContentfulExperience, LazyContentfulHeadline, LazyContentfulHeroArticleSection, LazyContentfulHeroOverviewSection, LazyContentfulHeroProductSection, LazyContentfulHeroSections, LazyContentfulImage, LazyContentfulLink, LazyContentfulLinksGroup, LazyContentfulMediaTabs, LazyContentfulMultiExperience, LazyContentfulParagraph, LazyContentfulProductSeriesPage, LazyContentfulProductsListSection, LazyContentfulSolutionsArticlePage, LazyContentfulSpacer, LazyContentfulTable, LazyContentfulTabsSection, LazyContentfulTagCloudContainer, LazyContentfulTagOverviewSection, LazyContentfulTechnicalComponent, LazyContentfulTestimonialList, LazyContentfulTextImageTeaser, LazyContentfulTextImageTeaserList, LazyContentfulTextMedia, LazyContentfulTextTeaserCardList, LazyContentfulTile, LazyContentfulTiles, LazyContentfulVideo, LazyDownloadsDownloadCenterModalSuccessBlock, LazyDownloadsPardotFormIframe, LazyDownloadsDocumentsDocumentCenter, LazyDownloadsDocumentsDocumentCenterFilter, LazyDownloadsDocumentsDocumentCenterFilters, LazyDownloadsDocumentsDocumentCenterList, LazyDownloadsDocumentsDocumentCenterModal, LazyDownloadsDocumentsDocumentCenterModalContainer, LazyDownloadsDocumentsDocumentCenterProductList, LazyDownloadsDocumentsDocumentCenterSearchbar, LazyDownloadsDocumentsDocumentCenterStandaloneModal, LazyDownloadsDocumentsConstants, LazyDownloadsSoftwareCenter, LazyDownloadsSoftwareCenterFilter, LazyDownloadsSoftwareCenterFilters, LazyDownloadsSoftwareCenterModal, LazyDownloadsSoftwareCenterModalContainer, LazyDownloadsSoftwareCenterSearchbar, LazyDownloadsSoftwareCenterStandaloneModal, LazyLibAudienceWidget, LazyLibBreadcrumb, LazyLibCircleFlag, LazyLibDownloadCenter, LazyLibErrorBoundary, LazyLibExternalTool, LazyLibGroupedSections, LazyLibHeroCanvas, LazyLibIFrame, LazyLibInactiveLocaleMessage, LazyLibLazyLoad, LazyLibLocaleVersionOverlay, LazyLibLocaleVersionOverlayContainer, LazyLibPageContainer, LazyLibPageFooter, LazyLibPageHeader, LazyLibProductEnrichmentAboveTabSection, LazyLibProductEnrichmentCenterSection, LazyLibProductEnrichmentFooterSection, LazyLibProductEnrichmentTabElement, LazyLibRegionSelector, LazyLibResolveError, LazyLibRichTextRenderer, LazyLibSearchResults, LazyLibSearchResultsSkeleton, LazyLibSearchInput, LazyLibSearchSection, LazyLibSoftwareCenter, LazyLibTabSections, LazyLibTestCameraForm, LazyLibToolsLensSelectorInModal, LazyMapping, LazyShopCartToastContainer, LazyShopCartToastContainerContent, LazyShopExpandableInputList, LazyShopPrimevueSlider, LazyShopProductCardFooter, LazyShopProductDetailAddToCart, LazyShopProductDetailCoPilot, LazyShopProductDetailConfigureOptions, LazyShopProductDetailDistributors, LazyShopProductDetailFollowingProductLinks, LazyShopProductDetailHead, LazyShopProductDetailImages, LazyShopProductDetailProductAddons, LazyShopProductDetailTabDocuments, LazyShopProductDetailTabFeatures, LazyShopProductDetailTabSpecifications, LazyShopProductFeatures, LazyShopProductFilter, LazyShopProductFilterTags, LazyShopProductFilters, LazyShopProductListActions, LazyShopProductListPagination, LazyShopProductsList, LazyShopRelatedProducts, LazyShopReloadableProductList, LazyShopSlider, LazyShopSkeletonsProductDetailHeadSkeleton, LazyShopSkeletonsProductFilterSkeleton, LazyShopSkeletonsProductsListSectionSkeleton, LazyShopSkeletonsRelatedProductsSkeleton, LazyPrimeVueAutoComplete, LazyPrimeVueCalendar, LazyPrimeVueCascadeSelect, LazyPrimeVueCheckbox, LazyPrimeVueCheckboxGroup, LazyPrimeVueChips, LazyPrimeVueColorPicker, LazyPrimeVueDatePicker, LazyPrimeVueDropdown, LazyPrimeVueFloatLabel, LazyPrimeVueFluid, LazyPrimeVueIconField, LazyPrimeVueIftaLabel, LazyPrimeVueInputChips, LazyPrimeVueInputGroup, LazyPrimeVueInputGroupAddon, LazyPrimeVueInputIcon, LazyPrimeVueInputMask, LazyPrimeVueInputNumber, LazyPrimeVueInputOtp, LazyPrimeVueInputSwitch, LazyPrimeVueInputText, LazyPrimeVueKnob, LazyPrimeVueListbox, LazyPrimeVueMultiSelect, LazyPrimeVuePassword, LazyPrimeVueRadioButton, LazyPrimeVueRadioButtonGroup, LazyPrimeVueRating, LazyPrimeVueSelect, LazyPrimeVueSelectButton, LazyPrimeVueSlider, LazyPrimeVueTextarea, LazyPrimeVueToggleButton, LazyPrimeVueToggleSwitch, LazyPrimeVueTreeSelect, LazyPrimeVueButton, LazyPrimeVueButtonGroup, LazyPrimeVueSpeedDial, LazyPrimeVueSplitButton, LazyPrimeVueColumn, LazyPrimeVueRow, LazyPrimeVueColumnGroup, LazyPrimeVueDataTable, LazyPrimeVueDataView, LazyPrimeVueOrderList, LazyPrimeVueOrganizationChart, LazyPrimeVuePaginator, LazyPrimeVuePickList, LazyPrimeVueTree, LazyPrimeVueTreeTable, LazyPrimeVueTimeline, LazyPrimeVueVirtualScroller, LazyPrimeVueAccordion, LazyPrimeVueAccordionPanel, LazyPrimeVueAccordionHeader, LazyPrimeVueAccordionContent, LazyPrimeVueAccordionTab, LazyPrimeVueCard, LazyPrimeVueDeferredContent, LazyPrimeVueDivider, LazyPrimeVueFieldset, LazyPrimeVuePanel, LazyPrimeVueScrollPanel, LazyPrimeVueSplitter, LazyPrimeVueSplitterPanel, LazyPrimeVueStepper, LazyPrimeVueStepList, LazyPrimeVueStep, LazyPrimeVueStepItem, LazyPrimeVueStepPanels, LazyPrimeVueStepPanel, LazyPrimeVueTabView, LazyPrimeVueTabs, LazyPrimeVueTabList, LazyPrimeVueTab, LazyPrimeVueTabPanels, LazyPrimeVueTabPanel, LazyPrimeVueToolbar, LazyPrimeVueConfirmDialog, LazyPrimeVueConfirmPopup, LazyPrimeVueDialog, LazyPrimeVueDrawer, LazyPrimeVueDynamicDialog, LazyPrimeVueOverlayPanel, LazyPrimeVuePopover, LazyPrimeVueSidebar, LazyPrimeVueFileUpload, LazyPrimeVueBreadcrumb, LazyPrimeVueContextMenu, LazyPrimeVueDock, LazyPrimeVueMenu, LazyPrimeVueMenubar, LazyPrimeVueMegaMenu, LazyPrimeVuePanelMenu, LazyPrimeVueSteps, LazyPrimeVueTabMenu, LazyPrimeVueTieredMenu, LazyPrimeVueMessage, LazyPrimeVueInlineMessage, LazyPrimeVueToast, LazyPrimeVueCarousel, LazyPrimeVueGalleria, LazyPrimeVueImage, LazyPrimeVueImageCompare, LazyPrimeVueAvatar, LazyPrimeVueAvatarGroup, LazyPrimeVueBadge, LazyPrimeVueBlockUI, LazyPrimeVueChip, LazyPrimeVueInplace, LazyPrimeVueMeterGroup, LazyPrimeVueOverlayBadge, LazyPrimeVueScrollTop, LazyPrimeVueSkeleton, LazyPrimeVueProgressBar, LazyPrimeVueProgressSpinner, LazyPrimeVueTag, LazyPrimeVueTerminal, LazyPrimeVueForm, LazyPrimeVueFormField } from '#components'
const lazyGlobalComponents = [
  ["MappedComponent", LazyMappedComponent],
["MappedComponents", LazyMappedComponents],
["ContentfulAccordionSection", LazyContentfulAccordionSection],
["ContentfulAnimation", LazyContentfulAnimation],
["ContentfulBadge", LazyContentfulBadge],
["ContentfulCardCarouselSection", LazyContentfulCardCarouselSection],
["ContentfulColumns", LazyContentfulColumns],
["ContentfulContentPage", LazyContentfulContentPage],
["ContentfulContentSection", LazyContentfulContentSection],
["ContentfulContentTabs", LazyContentfulContentTabs],
["ContentfulCtaSection", LazyContentfulCtaSection],
["ContentfulCustomHTML", LazyContentfulCustomHTML],
["ContentfulExperience", LazyContentfulExperience],
["ContentfulHeadline", LazyContentfulHeadline],
["ContentfulHeroArticleSection", LazyContentfulHeroArticleSection],
["ContentfulHeroOverviewSection", LazyContentfulHeroOverviewSection],
["ContentfulHeroProductSection", LazyContentfulHeroProductSection],
["ContentfulHeroSections", LazyContentfulHeroSections],
["ContentfulImage", LazyContentfulImage],
["ContentfulLink", LazyContentfulLink],
["ContentfulLinksGroup", LazyContentfulLinksGroup],
["ContentfulMediaTabs", LazyContentfulMediaTabs],
["ContentfulMultiExperience", LazyContentfulMultiExperience],
["ContentfulParagraph", LazyContentfulParagraph],
["ContentfulProductSeriesPage", LazyContentfulProductSeriesPage],
["ContentfulProductsListSection", LazyContentfulProductsListSection],
["ContentfulSolutionsArticlePage", LazyContentfulSolutionsArticlePage],
["ContentfulSpacer", LazyContentfulSpacer],
["ContentfulTable", LazyContentfulTable],
["ContentfulTabsSection", LazyContentfulTabsSection],
["ContentfulTagCloudContainer", LazyContentfulTagCloudContainer],
["ContentfulTagOverviewSection", LazyContentfulTagOverviewSection],
["ContentfulTechnicalComponent", LazyContentfulTechnicalComponent],
["ContentfulTestimonialList", LazyContentfulTestimonialList],
["ContentfulTextImageTeaser", LazyContentfulTextImageTeaser],
["ContentfulTextImageTeaserList", LazyContentfulTextImageTeaserList],
["ContentfulTextMedia", LazyContentfulTextMedia],
["ContentfulTextTeaserCardList", LazyContentfulTextTeaserCardList],
["ContentfulTile", LazyContentfulTile],
["ContentfulTiles", LazyContentfulTiles],
["ContentfulVideo", LazyContentfulVideo],
["DownloadsDownloadCenterModalSuccessBlock", LazyDownloadsDownloadCenterModalSuccessBlock],
["DownloadsPardotFormIframe", LazyDownloadsPardotFormIframe],
["DownloadsDocumentsDocumentCenter", LazyDownloadsDocumentsDocumentCenter],
["DownloadsDocumentsDocumentCenterFilter", LazyDownloadsDocumentsDocumentCenterFilter],
["DownloadsDocumentsDocumentCenterFilters", LazyDownloadsDocumentsDocumentCenterFilters],
["DownloadsDocumentsDocumentCenterList", LazyDownloadsDocumentsDocumentCenterList],
["DownloadsDocumentsDocumentCenterModal", LazyDownloadsDocumentsDocumentCenterModal],
["DownloadsDocumentsDocumentCenterModalContainer", LazyDownloadsDocumentsDocumentCenterModalContainer],
["DownloadsDocumentsDocumentCenterProductList", LazyDownloadsDocumentsDocumentCenterProductList],
["DownloadsDocumentsDocumentCenterSearchbar", LazyDownloadsDocumentsDocumentCenterSearchbar],
["DownloadsDocumentsDocumentCenterStandaloneModal", LazyDownloadsDocumentsDocumentCenterStandaloneModal],
["DownloadsDocumentsConstants", LazyDownloadsDocumentsConstants],
["DownloadsSoftwareCenter", LazyDownloadsSoftwareCenter],
["DownloadsSoftwareCenterFilter", LazyDownloadsSoftwareCenterFilter],
["DownloadsSoftwareCenterFilters", LazyDownloadsSoftwareCenterFilters],
["DownloadsSoftwareCenterModal", LazyDownloadsSoftwareCenterModal],
["DownloadsSoftwareCenterModalContainer", LazyDownloadsSoftwareCenterModalContainer],
["DownloadsSoftwareCenterSearchbar", LazyDownloadsSoftwareCenterSearchbar],
["DownloadsSoftwareCenterStandaloneModal", LazyDownloadsSoftwareCenterStandaloneModal],
["LibAudienceWidget", LazyLibAudienceWidget],
["LibBreadcrumb", LazyLibBreadcrumb],
["LibCircleFlag", LazyLibCircleFlag],
["LibDownloadCenter", LazyLibDownloadCenter],
["LibErrorBoundary", LazyLibErrorBoundary],
["LibExternalTool", LazyLibExternalTool],
["LibGroupedSections", LazyLibGroupedSections],
["LibHeroCanvas", LazyLibHeroCanvas],
["LibIFrame", LazyLibIFrame],
["LibInactiveLocaleMessage", LazyLibInactiveLocaleMessage],
["LibLazyLoad", LazyLibLazyLoad],
["LibLocaleVersionOverlay", LazyLibLocaleVersionOverlay],
["LibLocaleVersionOverlayContainer", LazyLibLocaleVersionOverlayContainer],
["LibPageContainer", LazyLibPageContainer],
["LibPageFooter", LazyLibPageFooter],
["LibPageHeader", LazyLibPageHeader],
["LibProductEnrichmentAboveTabSection", LazyLibProductEnrichmentAboveTabSection],
["LibProductEnrichmentCenterSection", LazyLibProductEnrichmentCenterSection],
["LibProductEnrichmentFooterSection", LazyLibProductEnrichmentFooterSection],
["LibProductEnrichmentTabElement", LazyLibProductEnrichmentTabElement],
["LibRegionSelector", LazyLibRegionSelector],
["LibResolveError", LazyLibResolveError],
["LibRichTextRenderer", LazyLibRichTextRenderer],
["LibSearchResults", LazyLibSearchResults],
["LibSearchResultsSkeleton", LazyLibSearchResultsSkeleton],
["LibSearchInput", LazyLibSearchInput],
["LibSearchSection", LazyLibSearchSection],
["LibSoftwareCenter", LazyLibSoftwareCenter],
["LibTabSections", LazyLibTabSections],
["LibTestCameraForm", LazyLibTestCameraForm],
["LibToolsLensSelectorInModal", LazyLibToolsLensSelectorInModal],
["Mapping", LazyMapping],
["ShopCartToastContainer", LazyShopCartToastContainer],
["ShopCartToastContainerContent", LazyShopCartToastContainerContent],
["ShopExpandableInputList", LazyShopExpandableInputList],
["ShopPrimevueSlider", LazyShopPrimevueSlider],
["ShopProductCardFooter", LazyShopProductCardFooter],
["ShopProductDetailAddToCart", LazyShopProductDetailAddToCart],
["ShopProductDetailCoPilot", LazyShopProductDetailCoPilot],
["ShopProductDetailConfigureOptions", LazyShopProductDetailConfigureOptions],
["ShopProductDetailDistributors", LazyShopProductDetailDistributors],
["ShopProductDetailFollowingProductLinks", LazyShopProductDetailFollowingProductLinks],
["ShopProductDetailHead", LazyShopProductDetailHead],
["ShopProductDetailImages", LazyShopProductDetailImages],
["ShopProductDetailProductAddons", LazyShopProductDetailProductAddons],
["ShopProductDetailTabDocuments", LazyShopProductDetailTabDocuments],
["ShopProductDetailTabFeatures", LazyShopProductDetailTabFeatures],
["ShopProductDetailTabSpecifications", LazyShopProductDetailTabSpecifications],
["ShopProductFeatures", LazyShopProductFeatures],
["ShopProductFilter", LazyShopProductFilter],
["ShopProductFilterTags", LazyShopProductFilterTags],
["ShopProductFilters", LazyShopProductFilters],
["ShopProductListActions", LazyShopProductListActions],
["ShopProductListPagination", LazyShopProductListPagination],
["ShopProductsList", LazyShopProductsList],
["ShopRelatedProducts", LazyShopRelatedProducts],
["ShopReloadableProductList", LazyShopReloadableProductList],
["ShopSlider", LazyShopSlider],
["ShopSkeletonsProductDetailHeadSkeleton", LazyShopSkeletonsProductDetailHeadSkeleton],
["ShopSkeletonsProductFilterSkeleton", LazyShopSkeletonsProductFilterSkeleton],
["ShopSkeletonsProductsListSectionSkeleton", LazyShopSkeletonsProductsListSectionSkeleton],
["ShopSkeletonsRelatedProductsSkeleton", LazyShopSkeletonsRelatedProductsSkeleton],
["PrimeVueAutoComplete", LazyPrimeVueAutoComplete],
["PrimeVueCalendar", LazyPrimeVueCalendar],
["PrimeVueCascadeSelect", LazyPrimeVueCascadeSelect],
["PrimeVueCheckbox", LazyPrimeVueCheckbox],
["PrimeVueCheckboxGroup", LazyPrimeVueCheckboxGroup],
["PrimeVueChips", LazyPrimeVueChips],
["PrimeVueColorPicker", LazyPrimeVueColorPicker],
["PrimeVueDatePicker", LazyPrimeVueDatePicker],
["PrimeVueDropdown", LazyPrimeVueDropdown],
["PrimeVueFloatLabel", LazyPrimeVueFloatLabel],
["PrimeVueFluid", LazyPrimeVueFluid],
["PrimeVueIconField", LazyPrimeVueIconField],
["PrimeVueIftaLabel", LazyPrimeVueIftaLabel],
["PrimeVueInputChips", LazyPrimeVueInputChips],
["PrimeVueInputGroup", LazyPrimeVueInputGroup],
["PrimeVueInputGroupAddon", LazyPrimeVueInputGroupAddon],
["PrimeVueInputIcon", LazyPrimeVueInputIcon],
["PrimeVueInputMask", LazyPrimeVueInputMask],
["PrimeVueInputNumber", LazyPrimeVueInputNumber],
["PrimeVueInputOtp", LazyPrimeVueInputOtp],
["PrimeVueInputSwitch", LazyPrimeVueInputSwitch],
["PrimeVueInputText", LazyPrimeVueInputText],
["PrimeVueKnob", LazyPrimeVueKnob],
["PrimeVueListbox", LazyPrimeVueListbox],
["PrimeVueMultiSelect", LazyPrimeVueMultiSelect],
["PrimeVuePassword", LazyPrimeVuePassword],
["PrimeVueRadioButton", LazyPrimeVueRadioButton],
["PrimeVueRadioButtonGroup", LazyPrimeVueRadioButtonGroup],
["PrimeVueRating", LazyPrimeVueRating],
["PrimeVueSelect", LazyPrimeVueSelect],
["PrimeVueSelectButton", LazyPrimeVueSelectButton],
["PrimeVueSlider", LazyPrimeVueSlider],
["PrimeVueTextarea", LazyPrimeVueTextarea],
["PrimeVueToggleButton", LazyPrimeVueToggleButton],
["PrimeVueToggleSwitch", LazyPrimeVueToggleSwitch],
["PrimeVueTreeSelect", LazyPrimeVueTreeSelect],
["PrimeVueButton", LazyPrimeVueButton],
["PrimeVueButtonGroup", LazyPrimeVueButtonGroup],
["PrimeVueSpeedDial", LazyPrimeVueSpeedDial],
["PrimeVueSplitButton", LazyPrimeVueSplitButton],
["PrimeVueColumn", LazyPrimeVueColumn],
["PrimeVueRow", LazyPrimeVueRow],
["PrimeVueColumnGroup", LazyPrimeVueColumnGroup],
["PrimeVueDataTable", LazyPrimeVueDataTable],
["PrimeVueDataView", LazyPrimeVueDataView],
["PrimeVueOrderList", LazyPrimeVueOrderList],
["PrimeVueOrganizationChart", LazyPrimeVueOrganizationChart],
["PrimeVuePaginator", LazyPrimeVuePaginator],
["PrimeVuePickList", LazyPrimeVuePickList],
["PrimeVueTree", LazyPrimeVueTree],
["PrimeVueTreeTable", LazyPrimeVueTreeTable],
["PrimeVueTimeline", LazyPrimeVueTimeline],
["PrimeVueVirtualScroller", LazyPrimeVueVirtualScroller],
["PrimeVueAccordion", LazyPrimeVueAccordion],
["PrimeVueAccordionPanel", LazyPrimeVueAccordionPanel],
["PrimeVueAccordionHeader", LazyPrimeVueAccordionHeader],
["PrimeVueAccordionContent", LazyPrimeVueAccordionContent],
["PrimeVueAccordionTab", LazyPrimeVueAccordionTab],
["PrimeVueCard", LazyPrimeVueCard],
["PrimeVueDeferredContent", LazyPrimeVueDeferredContent],
["PrimeVueDivider", LazyPrimeVueDivider],
["PrimeVueFieldset", LazyPrimeVueFieldset],
["PrimeVuePanel", LazyPrimeVuePanel],
["PrimeVueScrollPanel", LazyPrimeVueScrollPanel],
["PrimeVueSplitter", LazyPrimeVueSplitter],
["PrimeVueSplitterPanel", LazyPrimeVueSplitterPanel],
["PrimeVueStepper", LazyPrimeVueStepper],
["PrimeVueStepList", LazyPrimeVueStepList],
["PrimeVueStep", LazyPrimeVueStep],
["PrimeVueStepItem", LazyPrimeVueStepItem],
["PrimeVueStepPanels", LazyPrimeVueStepPanels],
["PrimeVueStepPanel", LazyPrimeVueStepPanel],
["PrimeVueTabView", LazyPrimeVueTabView],
["PrimeVueTabs", LazyPrimeVueTabs],
["PrimeVueTabList", LazyPrimeVueTabList],
["PrimeVueTab", LazyPrimeVueTab],
["PrimeVueTabPanels", LazyPrimeVueTabPanels],
["PrimeVueTabPanel", LazyPrimeVueTabPanel],
["PrimeVueToolbar", LazyPrimeVueToolbar],
["PrimeVueConfirmDialog", LazyPrimeVueConfirmDialog],
["PrimeVueConfirmPopup", LazyPrimeVueConfirmPopup],
["PrimeVueDialog", LazyPrimeVueDialog],
["PrimeVueDrawer", LazyPrimeVueDrawer],
["PrimeVueDynamicDialog", LazyPrimeVueDynamicDialog],
["PrimeVueOverlayPanel", LazyPrimeVueOverlayPanel],
["PrimeVuePopover", LazyPrimeVuePopover],
["PrimeVueSidebar", LazyPrimeVueSidebar],
["PrimeVueFileUpload", LazyPrimeVueFileUpload],
["PrimeVueBreadcrumb", LazyPrimeVueBreadcrumb],
["PrimeVueContextMenu", LazyPrimeVueContextMenu],
["PrimeVueDock", LazyPrimeVueDock],
["PrimeVueMenu", LazyPrimeVueMenu],
["PrimeVueMenubar", LazyPrimeVueMenubar],
["PrimeVueMegaMenu", LazyPrimeVueMegaMenu],
["PrimeVuePanelMenu", LazyPrimeVuePanelMenu],
["PrimeVueSteps", LazyPrimeVueSteps],
["PrimeVueTabMenu", LazyPrimeVueTabMenu],
["PrimeVueTieredMenu", LazyPrimeVueTieredMenu],
["PrimeVueMessage", LazyPrimeVueMessage],
["PrimeVueInlineMessage", LazyPrimeVueInlineMessage],
["PrimeVueToast", LazyPrimeVueToast],
["PrimeVueCarousel", LazyPrimeVueCarousel],
["PrimeVueGalleria", LazyPrimeVueGalleria],
["PrimeVueImage", LazyPrimeVueImage],
["PrimeVueImageCompare", LazyPrimeVueImageCompare],
["PrimeVueAvatar", LazyPrimeVueAvatar],
["PrimeVueAvatarGroup", LazyPrimeVueAvatarGroup],
["PrimeVueBadge", LazyPrimeVueBadge],
["PrimeVueBlockUI", LazyPrimeVueBlockUI],
["PrimeVueChip", LazyPrimeVueChip],
["PrimeVueInplace", LazyPrimeVueInplace],
["PrimeVueMeterGroup", LazyPrimeVueMeterGroup],
["PrimeVueOverlayBadge", LazyPrimeVueOverlayBadge],
["PrimeVueScrollTop", LazyPrimeVueScrollTop],
["PrimeVueSkeleton", LazyPrimeVueSkeleton],
["PrimeVueProgressBar", LazyPrimeVueProgressBar],
["PrimeVueProgressSpinner", LazyPrimeVueProgressSpinner],
["PrimeVueTag", LazyPrimeVueTag],
["PrimeVueTerminal", LazyPrimeVueTerminal],
["PrimeVueForm", LazyPrimeVueForm],
["PrimeVueFormField", LazyPrimeVueFormField],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
